import { Spin, Form } from 'antd';
import { useState } from 'react';
import { Forum } from '../../../../models/forum';
import { createForum } from '../../../../service/forum';
import { createErrorNotification, createSuccessNotification } from '../../../../service/notification';
import Button from '../../../../components/Button/Button';
import Input from '../../../../components/Input/Input';
import FormItem from '../../../../components/FormItem/FormItem';
import styles from './CreateForum.module.scss';

type Props = Pick< Forum, 'clubId' | 'userId'> 
& {
  refetchData: () => void
};

export const CreateForum = ({ clubId, userId, refetchData }: Props) => {

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (payload) => {
    if(loading) return;

    setLoading(true);

    const {error, success} = await createForum({
      title: payload.title
    }, clubId, userId);

    setLoading(false);
      
    if(error) return createErrorNotification(error);
    createSuccessNotification('Fórum criado!');

    refetchData();
  }


  return(
    <div className={styles.createForm}>
      <Form 
        layout="vertical" 
        form={form}
        onFinish={onFinish}
        id="formLogin" 
        className={styles.FormContainer}
      >
        <FormItem
          label="Título do Fórum"
          name="title"
          rules={[
            {
              required: true,
              message: 'Por favor, digite um título.',
            },
            {
              max: 255,
              message: 'Título deve ter entre 1 e 255 caracteres.',
            }
          ]}
          required
        >
          <Input style={styles.input} placeholder="Título do fórum de discussão"/>
        </FormItem>
        <Spin spinning={loading}>
          <Button submit style={styles.button}>Criar Fórum do Clube</Button>
        </Spin>
      </Form>
    </div>    
  );
}
